import React from 'react';

import ListItem from '@material-ui/core/ListItem';
import { Link } from 'react-router-dom';

export interface SidebarListItemProps {
  to: string;
}

export const SidebarListItem: React.FC<React.PropsWithChildren<SidebarListItemProps>> =
  React.forwardRef((props, ref) => {
    const { to, children } = props;

    return (
      <ListItem
        ref={ref}
        component={({ className }) => {
          return (
            <Link className={className} to={to}>
              <>{children}</>
            </Link>
          );
        }}
      />
    );
  });
